<template>
  <div class="resourceConfig">
    <div class="leftBox">
      <basic-container>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>资源组</span>
          </div>
          <div class="query-form-wrap">
            <el-form :inline="true" :model="searchForm" :size="formSize">
              <el-form-item>
                <el-input v-model="searchForm.code" placeholder="资源组编号"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="searchForm.name" placeholder="名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-select size="small" filterable clearable v-model="searchForm.clientType" placeholder="客户端类型">
                  <el-option v-for="(item, index) in AppBizdictClientTypeList" :key="index" :label="item.bizValue"
                    :value="item.bizKey"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select size="small" filterable clearable v-model="searchForm.tag" placeholder="标签">
                  <el-option v-for="(item, index) in AppBizdictTagsList" :key="index" :label="item.bizValue"
                    :value="item.bizKey"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-date-picker v-model="searchForm.date" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
                  start-placeholder="更新开始日期" end-placeholder="更新结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button :loading="listLoading" icon="el-icon-search" type="primary" @click="doSearch">查询</el-button>
                <el-button type="success" plain icon="el-icon-delete" @click="searchClear">清空</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="clearfix">
            <avue-crud ref="crud" :option="optionParent" :table-loading="loading" :data="dataParent" :page="pageParent"
              v-model="formParent" :permission="permissionList" :before-open="beforeOpen" @row-del="rowDel"
              @row-update="rowUpdate" @row-save="rowSave" @row-click="handleRowClick" @search-change="searchChange"
              @search-reset="searchReset" @selection-change="selectionChange" @current-change="currentChange"
              @size-change="sizeChange" @refresh-change="refreshChange" @on-load="onLoadParent"
              :upload-error="uploadError" :upload-before="uploadBefore">
              <template slot="menuLeft">
                <el-button v-auth="'resourceConfig_log_hit_query'" type="primary" size="small" @click="handleHitQuery">
                  命中查询
                </el-button>
                <el-button type="danger" size="small" icon="el-icon-delete" v-if="permission.dict_delete" plain
                  @click="handleDelete">
                  删 除
                </el-button>
              </template>

              <template slot="screenshotUrl" slot-scope="{row}">
                <el-image :src="row.screenshotUrl" style="width:100px;height:50px;cursor:pointer;"
                  @click="handleShowImage(row.screenshotUrl)"></el-image>
              </template>

              <template slot="clientType" slot-scope="{row}">
                <div v-if="row.clientType">
                  <el-tag v-for="(item, index) in row.clientType.split(',')" :key="index" style="margin: 3px;">
                    {{ showClientTypeName(item, AppBizdictClientTypeList) }}
                  </el-tag>
                </div>
              </template>
              <template slot="tags" slot-scope="{row}">
                <div v-if="row.tags">
                  <el-tag type="danger" v-for="(item, index) in row.tags.split(',')" :key="index" style="margin: 3px;">
                    {{ showClientTypeName(item, AppBizdictTagsList) }}
                  </el-tag>
                </div>
              </template>

              <template slot="tipsForm">
                <div class="tipsForm">
                  <div class="tit">命名规范</div>
                  <div class="rules">1. <strong>资源组编号</strong>采用功能位置的英文小写+下划线的形式命名</div>
                  <div class="rules_ex">例如：移动安卓首页轮播 ===> "app_android_home_banner"</div>
                  <div class="rules">2. <strong>资源组名称</strong>尽可能完整描述功能及位置</div>
                  <div class="rules_ex">例如：移动端安卓首页轮播</div>
                  <div class="rules">3. <strong>标签</strong>勾选对应功能模块，便于日后易于检索及维护</div>
                </div>
              </template>
              <template slot-scope="{row}" slot="isSealed">
                <el-tag>{{ row.isSealed === 0 ? '否' : '是' }}</el-tag>
              </template>
            </avue-crud>
          </div>
        </el-card>
      </basic-container>
    </div>
    <dragAdjustWidth wrapperBox="resourceConfig"></dragAdjustWidth>
    <div class="rightBox">
      <basic-container>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>[{{ dictValue }}] 资源配置</span>
          </div>
          <div class="search-add-row">
            <el-form :inline="true" :model="childQuery">
              <el-form-item>
                <el-input v-model="childQuery.code" placeholder="资源位code" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="childQuery.title" placeholder="标题&描述" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-select v-model="childQuery.userTags" placeholder="用户标签" clearable multiple filterable>
                  <el-option v-for="item in userTagsList" :key="item.id" :label="`(${item.id}) ${item.tag}`" :value="item.tag"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="childQuery.status" placeholder="状态" clearable>
                  <el-option label="上架" :value="1"></el-option>
                  <el-option label="下架" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="childQuery.auditStatus" placeholder="审核状态" clearable>
                  <el-option label="草稿" :value="1"></el-option>
                  <el-option label="审核中" :value="2"></el-option>
                  <el-option label="审核通过" :value="3"></el-option>
                  <el-option label="审核不通过" :value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="clearfix">
            <avue-crud ref="crudChild" :option="optionChild" :table-loading="loadingChild" :data="dataChild"
              v-model="formChild" :permission="permissionList" :before-open="beforeOpenChild"
              @row-update="rowUpdateChild" @row-save="rowSaveChild"
              @selection-change="selectionChangeChild"
              @current-change="currentChangeChild" @size-change="sizeChangeChild" @refresh-change="refreshChangeChild"
              @on-load="onLoadChild" :upload-before="uploadBefore"
              :upload-after="uploadAfter" :upload-error="uploadError" :span-method="handleTableSpan"
              @rowAdd="handelChildAdd">
              <template slot="menuLeft">
                <el-button type="primary" @click="handleSearchChild">搜索</el-button>
                <el-button type="primary" plain @click="handleAddChild">新增</el-button>
                <el-button type="warning" plain @click="handleBatchReview">批量提交审核</el-button>
                <el-button type="info" plain @click="handleBatchReviewRecord">批量审核记录</el-button>
              </template>
              <template slot="index" slot-scope="{row}">
                {{ getMergedIndexText(row, getRowIndex(row)) }}
              </template>
              <template slot="sortOrderOption" slot-scope="{row}">
                <!-- 排序为全组重排，搜索态下 code 集合不完整，故禁用排序操作 -->
                <el-tooltip :disabled="!isChildSearching" content="请先清空搜索条件后再调整排序" placement="top">
                  <span>
                    <el-button v-if='getRowIndex(row) !== 0' type="text" :disabled="isChildSearching" @click="handleSortOrderOption(row, 'up')">上移</el-button>
                    <el-button v-if='canMoveDown(row, getRowIndex(row))' type="text" :disabled="isChildSearching" @click="handleSortOrderOption(row, 'down')">下移</el-button>
                    <el-button v-if='getRowIndex(row) !== 0' type="text" :disabled="isChildSearching" @click="handleSortOrderOption(row, 'top')">置顶</el-button>
                  </span>
                </el-tooltip>
              </template>
              <template slot-scope="{row}" slot="menu">
                <el-button v-if="row.auditStatus !== 2" v-auth="'resourceConfig_log'" @click="openEditModal(row)"
                  type="text" size="small">编辑</el-button>
                <el-button v-if="row.auditStatus !== 2" v-auth="'resourceConfig_log'" @click="rowDelChild(row)"
                  type="text" size="small">删除</el-button>
                <el-button v-if="row.auditStatus === 1 || row.auditStatus === 2" v-auth="'resourceConfig_log'"
                  @click="handleReview(row)" type="text" size="small">{{ row.auditStatus ===
                    1 ? '提交审核' : '撤销审核' }}</el-button>
                <el-button v-auth="'resourceConfig_log'" @click="handleViewOperateLog(row)" type="text"
                  size="small">日志</el-button>
              </template>
              <template slot="icon" slot-scope="{row}">
                <el-image v-if="row.icon" :src="row.icon" style="width:100px;height:50px;cursor:pointer;"
                  @click="handleShowImage(row.image)"></el-image>
              </template>
              <template slot="image" slot-scope="{row}">
                <video v-if="row.image && row.image.indexOf('.mp4') !== -1" :src="row.image"
                  style="width:100px;height:50px;cursor:pointer;" @click="showImage(row.image, 'video')"></video>
                <el-image v-if="row.image && row.image.trim()" :src="row.image"
                  style="width:100px;height:50px;cursor:pointer;" @click="handleShowImage(row.image)">
                </el-image>
              </template>
              <template slot="video" slot-scope="{row}">
                <video v-if="row.video" :src="row.video" style="width:100px;height:50px;cursor:pointer;"
                  @click="handleShowImage(row.video, 'video')"></video>
              </template>
              <template slot="richTextForm" slot-scope="{row}">
                <!-- 纯内容模式：直接用 textarea 双向绑定，内容原样进原样出。
                     不能复用富文本编辑器——编辑器在弹窗打开的那一刻就会解析并规范化内容
                     （补全标签、规范属性引号、转义 HTML 实体），运营存的 JSON 会被改写。 -->
                <el-input v-if="row.richTextMode === richTextModePure" type="textarea" v-model="row.richText"
                  :autosize="{ minRows: 8, maxRows: 20 }" placeholder="纯内容模式：内容原样保存，不做任何转换"></el-input>
                <avue-ueditor v-else ref="editor" v-model="row.richText" v-bind="richTextOptions"></avue-ueditor>
              </template>
              <template slot="videoForm" slot-scope="{row}">
                <div>
                  <el-upload class="upload-demo" :before-upload="beforeVideoUpload" :http-request="videoUpload"
                    :show-file-list="false">
                    <el-button size="medium" type="primary"> 上传 </el-button>
                  </el-upload>
                  <div class="uidsSlot_text">
                    <a v-if="formChild.video" :href="formChild.video" target="_blank"
                      style="outline: none;color: skyblue;">
                      {{ formChild.video }}
                    </a>
                  </div>
                </div>
              </template>
              <!-- TODO: 以前只有用户 uid, 多出的一个,需要确认重新配置 -->
              <template slot="uuidsForm" slot-scope="{row}">
                <div class="uidsSlot">
                  <div class="uidsSlot_btn">
                    <el-button class="_btn" size="mini" type="primary"
                      @click="downloadTemplate(row.id, 'exportUuids')">下载导入模板</el-button>
                    <el-upload class="_btn" :show-file-list="false" :action="actionUUidUrl"
                      :before-upload="beforeUpload" :on-success="(response, file) => {
                        uuidsUploadSuccess(response, file)
                        row.uuids = response.data.uuids
                      }" :headers="headers" :multiple="false">
                      <el-button size="mini" type="primary"> 上传 </el-button>
                    </el-upload>
                  </div>
                  <div class="uidsSlot_text">
                    {{ uuidsUploadData.name }}
                    <span>
                      成功上传{{ uuidsUploadData.successNum }}，失败{{ uuidsUploadData.failNum }}
                    </span>
                  </div>
                </div>
              </template>
              <template slot="uidsForm" slot-scope="{row}">
                <div class="uidsSlot">
                  <div class="uidsSlot_btn">
                    <el-button class="_btn" size="mini" type="primary"
                      @click="downloadTemplate(row.id, 'exportUids')">下载导入模板
                    </el-button>
                    <el-upload class="_btn" :show-file-list="false" :action="actionUrl" :before-upload="beforeUpload"
                      :on-success="(response, file) => {
                        uidsUploadSuccess(response, file)
                        row.uids = response.data.uids
                      }" :headers="headers" :multiple="false">
                      <el-button size="mini" type="primary"> 上传 </el-button>
                    </el-upload>
                  </div>
                  <div class="uidsSlot_text">
                    {{ uidsUploadData.name }}
                    <span>
                      成功上传{{ uidsUploadData.successNum }}，失败{{ uidsUploadData.failNum }}
                    </span>
                  </div>
                </div>
              </template>
              <template slot="appidFilterList" slot-scope="{row}">
                <template v-if="row.appidFilterNames">
                  <template v-if="row.appidFilterNames.split(';').length < 5">
                    <el-tag v-for="(item, index) in row.appidFilterNames.split(';')" :key="index">
                      {{ item }}
                    </el-tag>
                  </template>
                  <template v-else>
                    <el-tag>{{ row.appidFilterNames.split(';')[0] }}</el-tag>
                    <el-popover placement="right" width="400" trigger="click">
                      <div>
                        <el-tag size="mini" v-for="(item, index) in row.appidFilterNames.split(';')" :key="index">
                          {{ item }}</el-tag>
                      </div>
                      <el-tag size="mini" slot="reference" class="el-icon-right">展开更多</el-tag>
                    </el-popover>
                  </template>
                </template>
              </template>
              <template slot="userTagsForm" slot-scope="{row}">
                <el-select 
                  v-model="row.userTags" 
                  multiple 
                  filterable 
                  collapse-tags
                  placeholder="请选择用户标签"
                  style="width: 100%">
                  <el-option
                    v-for="item in userTagsList"
                    :key="item.id"
                    :label="`(${item.id})${item.tag}`"
                    :value="item.tag">
                  </el-option>
                </el-select>
              </template>
              <template slot="userTags" slot-scope="{row}">
                <div v-if="row.userTags && row.userTags.length > 0">
                  <el-tag 
                    v-for="tag in row.userTags" 
                    :key="tag" 
                    size="mini" 
                    style="margin: 2px;">
                    {{ getUserTagName(tag) }}
                  </el-tag>
                </div>
                <span v-else>-</span>
              </template>
              <template slot-scope="scope" slot="eventType">
                {{ getEventTypeName(scope.dic, scope.row.eventType) }}
              </template>
              <template slot-scope="scope" slot="userTypes">
                {{ scope.row.userTypes | mapUserTagsToDict(scope.dic) }}
              </template>
              <template v-if="formChild.appidFilterType != 0" slot-scope="scope" slot="appidFilterListForm">
                <el-input type="textarea" @focus="handleClick()" v-model="formChild.appidFilterNames"> </el-input>
              </template>
              <template slot-scope="{row}" slot="isSealed">
                <el-tag>{{ row.isSealed === 0 ? '否' : '是' }}</el-tag>
              </template>
              <template slot-scope="scope" slot="eventBodyForm">
                <el-input type="input" v-on:click.native="handleResponseClick(scope.row)" v-model="formChild.eventBody"
                  placeholder="请输入响应" />
              </template>
              <template slot-scope="{row}" slot="codeSearch">
                <el-input placeholder="请输入字典编号" v-model="childQuery.code"></el-input>
              </template>
              <template slot-scope="{row}" slot="titleSearch">
                <el-input placeholder="请输入标题" v-model="childQuery.title"></el-input>
              </template>
              <!-- <template slot-scope="{type,size,row,index}" slot="menu">
                <el-button @click="handleViewOperateLog(row)" icon="el-icon-document"  :size="size" :type="type" >日志</el-button>
              </template> -->
              <!-- <template slot-scope="scope">
                   <el-dialog
                    title="提示"
                    :visible.sync="dialogVisible"
                    width="30%"
                    :before-close="handleClose" append-to-body="true">
                    <span>这是一段信息</span>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogVisible = false">取 消</el-button>
                      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                    </span>
                  </el-dialog>
              </template> -->
            </avue-crud>
          </div>
        </el-card>
        <channel-popups :isRabbittactics="true" :app-id="formChild.appidFilterList"
          :visible.sync="activityForm.showPopups" @comfirm="handleConfirm"></channel-popups>

        <tow-dialog :visible.sync="eventbodtForm.dialogVisible" width="800px" @comfirm="callbackEvenBodyComfirm"
          dialogTitle="事件响应">
          <template slot="form">
            <el-form :model="eventbodtForm" label-width="120px" label-position="rigth">
              <el-form-item label="事件响应类型">
                <el-select clearable v-model="eventbodtForm.pdata.action" placeholder="请选择事件响应类型">
                  <el-option v-for="item in eventbodtForm.action" :key="item.id" :label="item.value" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="事件响应Code">
                <el-col :span="21">
                  <!-- <el-input  placeholder="请选择事件响应Code" v-model="eventbodtForm.pdata.actionCode"></el-input> -->
                  <selectBottom @HanderSelected="getValue" :selectedValue="eventbodtForm.pdata.actionCode">
                  </selectBottom>
                </el-col>
                <!-- <el-select clearable v-model="eventbodtForm.pdata.actionCode" placeholder="请选择事件响应Code">
                  <el-option
                    v-for="item in eventbodtForm.actionCode"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id">
                  </el-option>
                </el-select> -->
              </el-form-item>
              <el-form-item label="是否付费专辑">
                <el-select clearable v-model="eventbodtForm.pdata.isPay" placeholder="请选择专辑类型">
                  <el-option v-for="item in eventbodtForm.isPay" :key="item.id" :label="item.value" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="专辑ID">
                <el-col :span="21">
                  <el-input placeholder="请输入专辑ID" v-model="eventbodtForm.pdata.albumId"></el-input>
                </el-col>
              </el-form-item>
            </el-form>
          </template>
        </tow-dialog>

        <!-- 事件类型=投屏功能：事件响应改为下拉选择，选项复用投屏功能管理的响应类型字典 -->
        <tow-dialog :visible.sync="screenCastEventForm.dialogVisible" width="600px"
          @comfirm="callbackScreenCastEventComfirm" dialogTitle="事件响应">
          <template slot="form">
            <el-form :model="screenCastEventForm" label-width="120px" label-position="rigth">
              <el-form-item label="响应类型">
                <el-select clearable v-model="screenCastEventForm.pdata.responseType" placeholder="请选择响应类型">
                  <el-option v-for="item in screenCastResponseTypeList" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </template>
        </tow-dialog>
      </basic-container>
    </div>

    <HitQueryDialog ref="hitQueryDialogRef" />
    <ResourceItemOperateLogDialog ref="resourceItemOperateLogDialogRef" />
    <ResourceBatchReviewDialog ref="resourceBatchReviewDialogRef" @success="onLoadChild(pageChild)" />
    <ResourceBatchReviewRecordDialog ref="resourceBatchReviewRecordDialogRef" @success="onLoadChild(pageChild)" />
  </div>
</template>

<script>
import Message from '@/components/Message';
import selectBottom from './const/select-bottom.vue';
import dragAdjustWidth from '@/components/dragAdjustWidth'
import {
  getAppResourceGroups,
  getResourceChildListLocal,
  appResourceItemReview,
  AppResourceGroupsRemove,
  AppResourceGroupsSubmit,
  appResourceItemRemove,
  appResourceItemSubmit,
  getAppBizdictApi
} from "@/api/desk/notice";
import {
  getDictionary
} from "@/api/system/dictbiz";
import { getUserTagsDict, resetCodeSort } from "@/api/apps/resourceConfig";
import { getComponentTypeList } from "@/api/apps/appScreenManage";
import { optionParent, optionChild } from "./const/resourceOption";
import { mapGetters, mapActions } from "vuex";
// import AvueUeditor from 'avue-plugin-ueditor';
import ChannelPopups from '@/components/channel-popups';
import TowDialog from '@/components/tow-dialog';
import axios from 'axios'
import { getToken } from '@/util/auth'
import HitQueryDialog from './hit-query-dialog.vue'
import ResourceItemOperateLogDialog from './resource-item-operate-log-dialog.vue'
import ResourceBatchReviewDialog from './resource-batch-review-dialog.vue'
import ResourceBatchReviewRecordDialog from './resource-batch-review-record-dialog.vue'
// import { getRowSpanMapUtil } from '@/util';

// let rowSpanMap = null

// 事件类型（字典 APP_RESOURCE_CONFIG）：点击事件响应输入框时需要弹出专用配置窗的类型
const EVENT_TYPE_APP_JUMP = 4 // 应用内跳转
const EVENT_TYPE_SCREEN_CAST = 9 // 投屏功能

// 富文本模式：随表单持久化到后端字段 richTextMode，不再靠内容特征猜测
const RICH_TEXT_MODE_RICH = 1 // 富文本：avue-ueditor 编辑
const RICH_TEXT_MODE_PURE = 2 // 纯内容：textarea 原样存取，内容不经编辑器解析改写

export default {
  data() {
    return {
      // 富文本模式枚举，供模板判断当前该渲染哪种编辑控件
      richTextModePure: RICH_TEXT_MODE_PURE,
      // 富文本配置
      richTextOptions: {
        action: "/lebo-resource/oss/endpoint/put-file",
        propsHttp: { res: "data", url: "link" },
        customConfig: {
          focus: false,
          fontNames: [{ name: "黑体", value: "黑体" }, { name: '楷体', value: "楷体" }, { name: '宋体', value: '宋体' }, { name: "仿宋体", value: '仿宋体' },
          { name: '隶书', value: '隶书' }, { name: '方正黑体', value: '方正黑体' }, { name: '方正书宋', value: '方正书宋' }, { name: '方正仿宋', value: '方正仿宋' }
            , { name: '方正楷体', value: '方正楷体' }
          ],
        }
      },
      options: {
        userTags: [],
        userTypes: [],
      },
      oldUserTypes: '',
      // 打开表单时的事件类型，切换事件类型时用于判断是否恢复原事件响应
      oldEventType: '',
      AppBizdictTagsList: [],
      AppBizdictClientTypeList: [],
      userTagsList: [],
      uidsUploadData: {
        name: '',
        successNum: 0,
        failNum: 0
      },
      uuidsUploadData: {
        name: '',
        successNum: 0,
        failNum: 0
      },
      headers: {},
      actionUrl: process.env.VUE_APP_BASE_URL + '/lebo-desk/appresourceitem/uploadUids',
      actionUUidUrl: process.env.VUE_APP_BASE_URL + '/lebo-desk/appresourceitem/uploadUuids',
      dictValue: '暂无',
      parentCode: '',
      activityForm: {
        appId: '',
        channel: '',
        showPopups: false

      },
      searchForm: {},
      formSize: "small",
      showImage: '',
      parentId: -1,
      formParent: {},
      formChild: {
        groupId: '',
        appidFilterType: 0,
        eventBody: '',
        eventType: 1,
        userTags: [],
        userTypes: '',
        video: '',
        userTypesReal: '',
      },
      selectionList: [],
      query: {},

      childQuery: {},
      loading: true,
      loadingChild: true,
      pageParent: {
        pageSize: 10,
        pageSizes: [10, 30, 50, 100, 200],
        currentPage: 1,
        total: 0
      },
      pageChild: {
        pageSize: 10,
        pageSizes: [10, 30, 50, 100, 200],
        currentPage: 1,
        total: 0
      },
      dataParent: [],
      dataChild: [],
      dataChildSort: [],
      optionParent: optionParent,
      optionChild: optionChild,
      eventbodtForm: {
        dialogVisible: false,
        resultData: '',
        pdata: {},
        firstSelectEvent: '',
        action: [],
        isPay: [
          {
            id: "1",
            value: "付费专辑"
          },
          {
            id: "0",
            value: "免费专辑"
          },
        ]
      },
      // 投屏功能响应类型字典（APP_SCREEN_RESPONSE_TYPE，与投屏功能管理共用）
      screenCastResponseTypeList: [],
      screenCastEventForm: {
        dialogVisible: false,
        pdata: {
          responseType: ""
        }
      }
    };
  },
  watch: {
    'formChild.appidFilterType': {
      handler(v) {
        console.log('[watch.handlerChangeValue]', v)
        let appidFilterList = this.findObject(this.optionChild.column, 'appidFilterList')
        console.log('444', appidFilterList)
        let appidFilterType = this.findObject(this.optionChild.column, 'appidFilterType')
        console.log('4445', appidFilterType)

        if (v) {
          appidFilterType.row = false
          appidFilterList.display = true
        } else {
          appidFilterType.row = true
          appidFilterList.display = false
        }
      }
    },
    'formChild.eventType': {
      handler(v) {
        console.log("watch:formChild.eventType ", v)
        // 切回打开表单时的原事件类型才恢复原事件响应；切到其他类型一律清空，
        // 避免上一个类型的事件响应（如投屏功能的 {"responseType":"6"}）残留到新类型上
        this.formChild.eventBody = (v + '') === (this.oldEventType + '') ? this.oldEvenBody : '';
      },
    },
    'formChild.userTypes': {
      handler(newV, oldV) {

        console.log('watch:formChild.userTypes_newV', newV, typeof newV);
        this.formChild.userTypesReal = newV;

        console.log('watch:formChild.userTypes_newV', newV, typeof newV);
        console.log("watch:formChild.userTypes_oldV", oldV, typeof oldV)
        // this.formChild.userTypes = this.oldUserTypes;
      }
    },
  },
  components: {
    ChannelPopups,
    // AvueUeditor,
    TowDialog,
    selectBottom,
    dragAdjustWidth,
    HitQueryDialog,
    ResourceItemOperateLogDialog,
    ResourceBatchReviewDialog,
    ResourceBatchReviewRecordDialog
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.resourceConfig_add, false),
        delBtn: this.vaildData(this.permission.resourceConfig_delete, false),
        editBtn: this.vaildData(this.permission.resourceConfig_edit, false),
        viewBtn: false,
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
    // 是否处于子列表搜索态：childQuery 任一条件非空即为搜索态
    // 注意：状态值取自后端 AppResourceItem.status（1:上架 2:下架），此处按 ""/null/undefined 判空，不要改用 falsy 判断
    isChildSearching() {
      return Object.values(this.childQuery).some(value => {
        if (Array.isArray(value)) {
          return value.length > 0;
        }
        return value !== "" && value !== null && value !== undefined;
      });
    }
  },
  mounted() {
  },
  beforeUpdate() {
    this.uploadData = {
      name: '',
      successNum: 0,
      failNum: 0
    }
  },
  created() {
    console.log("开始查询数据")
    this.headers = { 'Lebo-Auth': 'bearer ' + getToken() }
    getDictionary({ code: 'APPS_JUMP_ACTION' }).then(res => {
      console.log(res.data.data)
      this.eventbodtForm.action = res.data.data.map(r => { return { "id": r.dictKey, "value": r.dictValue } })
      //this.eventbodtForm.action = [...this.eventbodtForm.action , ...listMap]

      console.log(this.eventbodtForm.action)
    })
    this.initAppBizdict()
    this.initUserTagsDict()
    this.initScreenCastResponseTypeDict()
  },
  methods: {
    handleError(event, row) {
      console.log('[4444]')
      event.target.style.display = "none"; // 图片加载失败就隐藏
      row.image = ""; // 彻底移除，避免重复请求
    },
    isHTML(str) {
      const htmlTagPattern = /<\/?[a-z][\s\S]*>/i;
      return htmlTagPattern.test(str);
    },
    /**
     * 解析富文本模式：优先取后端持久化的 richTextMode
     * 存量数据（后端为空）才回退到内容特征推断——该推断并不可靠（内容含标签字面量的 JSON 会被误判为富文本），
     * 仅用于兼容本次改动前落库的数据，运营改一次模式并保存后即以后端值为准
     */
    resolveRichTextMode(form) {
      const savedMode = Number(form.richTextMode)
      if (savedMode === RICH_TEXT_MODE_RICH || savedMode === RICH_TEXT_MODE_PURE) {
        return savedMode
      }
      return this.isHTML(form.richText) ? RICH_TEXT_MODE_RICH : RICH_TEXT_MODE_PURE
    },
    /**
     * 组装资源项提交参数
     * 两种模式下 richText 均由控件 v-model 直接维护：纯内容走 textarea 原样取值，
     * 富文本走 avue-ueditor。不再从编辑器 DOM 抠 innerText——纯内容模式下编辑器已被 v-if 销毁，
     * 且 innerText 仍会带出标签字面量，正是模式被判回富文本的成因
     */
    buildItemSubmitParams(row) {
      const params = Object.assign({}, row)
      params.richTextMode = this.resolveRichTextMode(row)
      return params
    },
    handleViewOperateLog(row) {
      console.log('5555')
      // TODO: 弹窗需要参数查询操作日志
      this.$refs.resourceItemOperateLogDialogRef.show(row)
    },
    /** 上传视频的事件 */
    async videoUpload(params) {
      const file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      try {
        const { data } = await axios.post(
          "/lebo-resource/oss/endpoint/put-file?code=lebotob",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );
        console.log("上传视频的响应", data);
        const result = data.data;
        if (data.code === 200) {
          /** 上传成功 */
          /** 赋值 */
          this.formChild.video = result.link;
          /** 提示用户 */
          Message.success("上传成功");
        }
      } catch (error) {
        throw new Error(error);
      }

    },
    /** 上传视频之前的校验 */
    beforeVideoUpload(file) {
      console.log('beforeVideoUpload', file);
      const isMp4 = (/.mp4/).test(file.name);
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isMp4) {
        this.$message.error('上传文件只能是 mp4 格式!');
      }
      if (!isLt50M) {
        this.$message.error('上传大小不能超过 50MB!');
      }
      return isMp4 && isLt50M;

    },
    // TODO:
    handleHitQuery() {
      this.$refs.hitQueryDialogRef.show()
    },
    showClientTypeName(i, list) {
      if (list.length) {
        let item = list.filter(item => { return item.bizKey == i })
        return item.length ? item[0].bizValue : '-'
      } else {
        return '-'
      }

    },
    initAppBizdict() {
      // 客户端类型
      getAppBizdictApi('RESOURCE_CLIENT_TYPE').then(res1 => {
        console.log('客户端类型', res1)
        this.AppBizdictClientTypeList = res1.data.data
        this.optionParent.column[3].dicData = this.AppBizdictClientTypeList.map(item => { return { label: item.bizValue, value: item.bizKey } })
      })

      getAppBizdictApi('RESOURCE_TAGS').then(res2 => {
        // 用户标签
        console.log('用户标签', res2)
        this.AppBizdictTagsList = res2.data.data

        this.optionParent.column[6].dicData = this.AppBizdictTagsList.map(item => { return { label: item.bizValue, value: item.bizKey } })
      })
    },
    // 获取用户标签字典数据
    initUserTagsDict() {
      getUserTagsDict().then(res => {
        console.log('用户标签字典', res)
        this.userTagsList = res.data.data || []
      }).catch(error => {
        console.error('获取用户标签字典失败', error)
      })
    },

    // 获取投屏功能响应类型字典（与投屏功能管理共用 APP_SCREEN_RESPONSE_TYPE）
    initScreenCastResponseTypeDict() {
      getComponentTypeList().then(res => {
        const dictList = res.data.data || []
        this.screenCastResponseTypeList = dictList.map(item => {
          return { label: item.dictValue, value: item.dictKey }
        })
      }).catch(error => {
        console.error('获取投屏功能响应类型字典失败', error)
      })
    },

    // 根据标签名称获取标签id和名称
    getUserTagName(tag) {
      const tagItem = this.userTagsList.find(item => item.tag === tag);
      return tagItem ? `(${tagItem.id})${tagItem.tag}` : tag;
    },

    // 事件类型字典（APP_RESOURCE_CONFIG）由 avue 按 dicUrl 异步加载，
    // 首次渲染时 dic 可能为空；行上的 eventType 也可能在字典中查无匹配。
    // 这里必须容错：直接取 filter(...)[0].dictValue 会抛 TypeError 打断整表渲染。
    getEventTypeName(dic, eventType) {
      if (eventType === null || eventType === undefined || eventType === '') {
        return '-';
      }
      const dictList = Array.isArray(dic) ? dic : [];
      const item = dictList.find(dict => dict.dictKey === eventType + '');
      // 查不到时先显示原值，字典加载完成后会自动重新渲染成对应文案
      return item ? item.dictValue : eventType;
    },

    // 获取行索引
    getRowIndex(row) {
      return this.dataChild.findIndex(item => item.id === row.id);
    },

    // 检查是否可以下移（考虑合并单元格）
    canMoveDown(row, rowIndex) {
      if (rowIndex === this.dataChild.length - 1) {
        return false;
      }
        
      const currentCode = row.code;
      
      // 检查后面是否还有相同 code 的行
      for (let i = rowIndex + 1; i < this.dataChild.length; i++) {
        if (this.dataChild[i].code != currentCode) {
          return true;
        }
      }
      
      return false;
    },

    // 表格合并单元格方法
    handleTableSpan({ row, column, rowIndex, columnIndex: _columnIndex }) {
      const currentCode = row.code;
      let startRow = rowIndex;
      let endRow = rowIndex;
      
      // 向前查找相同 code 的起始行
      for (let i = rowIndex - 1; i >= 0; i--) {
        if (this.dataChild[i].code === currentCode) {
          startRow = i;
        } else {
          break;
        }
      }
      
      // 向后查找相同 code 的结束行
      for (let i = rowIndex + 1; i < this.dataChild.length; i++) {
        if (this.dataChild[i].code === currentCode) {
          endRow = i;
        } else {
          break;
        }
      }
      
      // 处理序号列（index列）
      if (column.type === 'index' || column.property === 'index') {
        // 如果是合并区域的起始行，返回合并的行数
        if (startRow === rowIndex) {
          return {
            rowspan: endRow - startRow + 1,
            colspan: 1
          };
        } else {
          // 如果不是起始行，隐藏该单元格
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      
      if (column.property === 'code' || column.label === '排序') {
        // 如果是合并区域的起始行，返回合并的行数
        if (startRow === rowIndex) {
          return {
            rowspan: endRow - startRow + 1,
            colspan: 1
          };
        } else {
          // 如果不是起始行，隐藏该单元格
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      
      // 其他列不合并
      return {
        rowspan: 1,
        colspan: 1
      };
    },

    // 获取合并后的序号显示文本
    getMergedIndexText(row, rowIndex) {
      const currentCode = row.code;
      let startRow = rowIndex;
      
      // 向前查找相同 code 的起始行
      for (let i = rowIndex - 1; i >= 0; i--) {
        if (this.dataChild[i].code === currentCode) {
          startRow = i;
        } else {
          break;
        }
      }
      
      // 如果是合并区域的起始行，计算合并组序号
      if (startRow === rowIndex) {
        // 计算这是第几个不同的 code 组
        let groupIndex = 1;
        const processedCodes = new Set();
        
        for (let i = 0; i < startRow; i++) {
          const code = this.dataChild[i].code;
          if (!processedCodes.has(code)) {
            processedCodes.add(code);
            groupIndex++;
          }
        }
        
        return groupIndex.toString();
      }
      
      return '';
    },

    handleSortOrderOption(row, type) {
      // 兜底拦截：排序按全组重排，搜索态下 dataChildSort 不含被过滤掉的 code
      if (this.isChildSearching) {
        this.$message.warning("请先清空搜索条件后再调整排序");
        return;
      }

      this.$confirm(`确定移动该资源位吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let temp;

        const currentIndex = this.dataChildSort.findIndex(item => item === row.code);
        
        switch (type) {
          case 'up':
            temp = this.dataChildSort[currentIndex];
            this.dataChildSort[currentIndex] = this.dataChildSort[currentIndex - 1];
            this.dataChildSort[currentIndex - 1] = temp;
            break;
          case 'down':
            temp = this.dataChildSort[currentIndex];
            this.dataChildSort[currentIndex] = this.dataChildSort[currentIndex + 1];
            this.dataChildSort[currentIndex + 1] = temp;
            break;
          case 'top':
            temp = this.dataChildSort[currentIndex];
            this.dataChildSort.splice(currentIndex, 1);
            this.dataChildSort.unshift(temp);
            break;
        }
        
        resetCodeSort({ groupId: row.groupId }, this.dataChildSort).then(() => {
          this.$message({
            type: "success",
            message: "操作成功!"
          });

          this.handleSearchChild();
        }).catch((error) => {
        console.log(error)
        })
      })
    },

    // 提交审核
    handleReview(row) {
      const obj = {
        auditType: row.auditStatus,
        id: row.id
      }
      appResourceItemReview(obj).then(() => {
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        this.onLoadChild(this.pageChild);
        this.$refs.crudChild.toggleSelection();
      }).catch((error) => {
        console.log(error)
        this.onLoadChild(this.pageChild);
        this.$refs.crudChild.toggleSelection();
      })

    },
    // 下载uids模板
    downloadTemplate(id = '', option) {
      axios({
        method: 'get',
        url: process.env.VUE_APP_BASE_URL + `/lebo-desk/appresourceitem/${option}?id=${id}`,
        responseType: 'blob'
      }).then(res => {
        console.log(res)
        var blob = res.data//blob对象
        var reader = new FileReader();
        reader.readAsDataURL(blob)
        reader.onload = function (e) {
          const a = document.createElement('a')
          if (option == 'exportUids') {
            a.download = 'UID-excel.xlsx'
          } else {
            a.download = 'UUID-excel.xlsx'
          }
          // a.download = 'UID-excel.xlsx'
          a.href = e.target.result
          a.click()
        }
      })
    },
    // 上传前校验
    beforeUpload(file) {
      const isxlsx = (/.xlsx|.xls/).test(file.name);
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isxlsx) {
        this.$message.error('上传文件只能是 xlsx格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传大小不能超过 5MB!');
      }
      return isxlsx && isLt5M;
    },
    //上传后接口返回
    uidsUploadSuccess(response, file) {
      if (response.code != 200) {
        this.$message({
          type: "error",
          message: "文件读取失败，请注意模板格式!"
        });
      }
      console.log('file', file);

      this.uidsUploadData = {
        name: file.name,
        successNum: response.data.successNum,
        failNum: response.data.failNum,
        uids: response.data.uids
      }
    },
    uuidsUploadSuccess(response, file) {
      if (response.code != 200) {
        this.$message({
          type: "error",
          message: "文件读取失败，请注意模板格式!"
        });
      }
      this.uuidsUploadData = {
        name: file.name,
        successNum: response.data.successNum,
        failNum: response.data.failNum,
        uuids: response.data.uuids
      }
    },
    ...mapActions('runActivityManage', ['clearDicts']),
    uploadBefore(file, done, loading, column) {
      const fileName = file.name.substring(0, file.name.lastIndexOf('.'))
      const suffix = file.name.substring(file.name.lastIndexOf('.'))
      const newName = fileName + '_' + Date.now() + suffix
      // image 大小限制改为 5M
      let imgSize = 5 * 1024 * 1024
      let videoSize = 20 * 1024 * 1024
      if (column.prop === "image" || column.prop === "icon") {

        if (file.size > imgSize) {
          this.$message.error('上传图片过大')
          loading();
        } else {
          const newFile = new File([file], newName, { type: file.type })
          done(newFile);

        }
      } else if (file.type === "video/mp4") {
        if (file.size > videoSize) {
          this.$message.error('上传视频过大')
          loading();
        } else {
          const newFile = new File([file], newName, { type: file.type })
          done(newFile);
        }
      } else {
        done()
      }
    },
    uploadError(error) {
      this.$message.error(error);
    },

    handleShowImage(url, type) {
      console.log('handleShowImage', url, type);

      let _dom = type === 'video' ? type + ' controls' : 'img'
      this.$alert(`<${_dom} src='` + url + "' style='width:100%'>", '图片/视频展示', {
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        customClass: 'showImage'
      });
    },
    // 选择渠道
    handleConfirm(data) {
      const { isAll, appId, channel } = data;
      this.formChild.appidFilterList = appId
      this.formChild.appidFilterNames = channel
      if (isAll) {
        this.channel = 1;
        this.activityForm.appId = '';
        this.activityForm.channel = '';
      }
    },
    handleClick() {
      this.activityForm.showPopups = true
    },
    rowSave(row, done, loading) {
      const form = {
        ...row,
        dictKey: -1,
      };
      // 处理提交数据
      if (Array.isArray(form.clientType) && form.clientType.length) {
        form.clientType = form.clientType.join()
      }
      if (Array.isArray(form.tags)) {
        form.tags = form.tags.length ? form.tags.join() : ''
      }
      console.log('rowSave', form);

      AppResourceGroupsSubmit(form).then(() => {
        this.onLoadParent(this.pageParent);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate(row, index, done, loading) {
      let form = row
      // 处理提交数据
      if (Array.isArray(form.clientType) && form.clientType.length) {
        form.clientType = form.clientType.join()
      }
      if (Array.isArray(form.tags)) {
        form.tags = form.tags.length ? form.tags.join() : ''
      }
      AppResourceGroupsSubmit(form).then(() => {
        this.onLoadParent(this.pageParent);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return AppResourceGroupsRemove(row.id);
        })
        .then(() => {
          this.onLoadParent(this.pageParent);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
    },
    handleRowClick(row) {
      console.log('点击资源组的行事件', row);

      this.parentId = row.id;
      this.dictValue = row.name;
      this.parentCode = row.code;
      //his.$refs.crudChild.value.code = "";
      this.$refs.crudChild.value.parentId = row.id;
      this.$refs.crudChild.option.column.filter(item => {
        if (item.prop === "code") {
          item.value = '';
        }

        if (item.prop === "groupId") {
          item.value = row.id;
        }
      });

      this.onLoadChild(this.pageChild);
    },
    searchReset() {
      this.query = {};
      this.onLoadParent(this.pageParent);
    },
    searchChange(params, done) {
      this.query = params;
      this.pageParent.currentPage = 1;
      this.onLoadParent(this.pageParent, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return AppResourceGroupsRemove(this.ids);
        })
        .then(() => {
          this.onLoadParent(this.pageParent);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      console.log(type, '打开类型暂时不处理')
      // if (["add"].includes(type)) {
      //   this.formChild.appidFilterType = 0
      // }
      done();
    },
    openEditModal(row) {
      // 使用 `crudChild` 的 `open` 方法来打开编辑弹窗
      this.$refs.crudChild.rowEdit(row);
    },
    currentChange(currentPage) {
      this.pageParent.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.pageParent.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoadParent(this.pageParent, this.query);
    },
    rowSaveChild(row, done, loading) {
      if (row.modAns.length === 0) {
        row.modAns = ''
      }
      if (row.userTypes.length === 0) {
        row.userTypes = ''
      }
      // 防止接口报错
      if (row.uids === '') {
        row.uids = []
      }
      if (row.uuids === '') {
        row.uuids = []
      }

      /** 把code替换成id */
      row.groupId = this.parentId
      
      // 处理userTags - 从自定义选择器获取数据
      if (row.userTags && Array.isArray(row.userTags)) {
        row.userTags = row.userTags.join(',')
      } else if (!row.userTags) {
        row.userTags = ''
      }
      
      if (row.userTypesReal && row.userTypesReal !== 'undefined') {
        row.userTypes = row.userTypesReal
        this.oldUserTypes = row.userTypesReal
      }
      if (!row.userTypes.length) {
        row.userTypes = ''
      }
      const params = this.buildItemSubmitParams(row);
      appResourceItemSubmit(params).then(() => {
        this.onLoadChild(this.pageChild);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        this.oldUserTypes = ''
        console.log('rowSaveChild', this.formChild);

        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowUpdateChild(row, index, done, loading) {
      /** 把code替换成id */
      row.groupId = this.parentId
      
      // 处理userTags - 从自定义选择器获取数据
      if (row.userTags && Array.isArray(row.userTags)) {
        row.userTags = row.userTags.join(',')
      } else if (!row.userTags) {
        row.userTags = ''
      }
      
      if (row.userTypesReal && row.userTypesReal !== 'undefined') {
        row.userTypes = row.userTypesReal
        this.oldUserTypes = row.userTypesReal
      }
      if (!row.userTypes.length) {
        row.userTypes = ''
      }
      const params = this.buildItemSubmitParams(row);
      appResourceItemSubmit(params).then(() => {
        this.onLoadChild(this.pageChild);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        this.oldUserTypes = ''
        console.log('rowUpdateChild', this.formChild);
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowDelChild(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return appResourceItemRemove(row.id);
        })
        .then(() => {
          this.onLoadChild(this.pageChild);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        }).catch(()=>{
          this.onLoadChild(this.pageChild);
          this.$refs.crudChild.toggleSelection();
        });
    },
    handleSearchChild() {
      // 搜索功能
      this.pageChild.currentPage = 1;
      
      // 处理多选用户标签，将数组转换为逗号分隔的字符串
      const searchParams = { ...this.childQuery };
      if (Array.isArray(searchParams.userTags) && searchParams.userTags.length > 0) {
        searchParams.userTags = searchParams.userTags.join(',');
      }
      

      this.onLoadChild(this.pageChild, searchParams);
    },
    handleAddChild() {
      // 新增功能
      this.$refs.crudChild.rowAdd();
    },
    // 打开批量提交审核弹窗（仅提审当前资源组下的草稿态资源位）
    handleBatchReview() {
      this.$refs.resourceBatchReviewDialogRef.show(this.parentId);
    },
    // 打开批量审核记录弹窗（仅展示当前资源组下的批次）
    handleBatchReviewRecord() {
      // 未选中资源组时 parentId 仍为初始值 -1，此时按组过滤必然查不到数据，直接提示
      if (!this.parentId || this.parentId === -1) {
        this.$message.warning("请先选择资源组");
        return;
      }
      this.$refs.resourceBatchReviewRecordDialogRef.show(this.parentId);
    },
    selectionChangeChild(list) {
      this.selectionList = list;
    },
    selectionClearChild() {
      this.selectionList = [];
      this.$refs.crudChild.toggleSelection();
    },
    beforeOpenChild(done, type) {
      console.log('444')
      console.log(done, type)
      this.$nextTick(() => {
        this.$refs.crudChild.value.groupId = this.parentCode
        this.formChild.groupId = this.parentCode
      })
      console.log('打开新增/编辑对话框之前的事件', this.$refs.crudChild.value);
      console.log('打开新增/编辑对话框之前的事件', this.formChild);

      this.formChild.richTextMode = this.resolveRichTextMode(this.formChild)
      const isAdd = ["add"].includes(type)
      if (isAdd) {

        this.activityForm.channel = ''
        this.activityForm.appId = ''

        setTimeout(() => {
          this.formChild.appidFilterType = 0
          // 字典 dictKey 是字符串且列未配 dataType，element-ui select 按严格相等匹配，赋数字 0 会渲染成字面量 "0"
          // 该字段有 required 校验，置空串由 placeholder 引导运营主动选择
          this.formChild.eventType = ''
          this.formChild.status = 1
          this.formChild.eventBody = ''
        }, 0)

      } else {
        console.log('this.formChild', this.formChild);

        this.formChild.eventType = this.formChild.eventType + ''
      }
      this.uidsUploadData = {
        name: '',
        successNum: 0,
        failNum: 0
      }
      this.uuidsUploadData = {
        name: '',
        successNum: 0,
        failNum: 0
      }
      // 新增时无原始值，编辑时记录原事件类型与原事件响应，供切换事件类型时判断是否恢复
      this.oldEvenBody = isAdd ? '' : this.formChild.eventBody
      this.oldEventType = isAdd ? '' : this.formChild.eventType
      console.log('[beforeOpenChild]', type, this.formChild)
      done();
    },
    currentChangeChild(currentPage) {
      this.pageChild.currentPage = currentPage;
    },
    sizeChangeChild(pageSize) {
      this.pageChild.pageSize = pageSize;
    },
    refreshChangeChild() {
      this.onLoadChild(this.pageChild);
    },
    onLoadParent(page, params = {}) {
      this.loading = true;

      let data = { ...this.searchForm }
      // 处理提交数据
      if (Array.isArray(data.clientType) && data.clientType.length) {
        data.clientType = data.clientType.join()
      }
      if (Array.isArray(data.tag) && data.tag.length) {
        data.tag = data.tag.join()
      }
      if (Array.isArray(data.date) && data.date.length) {
        data.staUpdateDate = data.date[0]
        data.endUpdateDate = data.date[1]
      }

      getAppResourceGroups(
        page.currentPage,
        page.pageSize,
        Object.assign(params, data)
      ).then(res => {
        const data = res.data.data;
        this.pageParent.total = data.total;
        this.dataParent = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
    onLoadChild(page, params = {}) {
      this.loadingChild = true;

      const requestParams = { ...this.childQuery, ...params };
      getResourceChildListLocal(
        page.currentPage,
        page.pageSize,
        this.parentId,
        requestParams
      ).then(res => {
        const data = res.data.data;
        this.dataChild = data.map(item => {
          return {
            ...item,
            userTags: item.userTags ? item.userTags.split(',').filter(tag => tag.trim() !== '') : []
          }
        });

        this.dataChildSort = Array.from(new Set(this.dataChild.map(item => item.code)));
        this.loadingChild = false;
        this.selectionClear();
      })
    },
    handleResponseClick(row) {
      // 投屏功能 类型：事件响应改为从响应类型字典中下拉选择
      if (parseInt(row.eventType) === EVENT_TYPE_SCREEN_CAST) {
        this.openScreenCastEventDialog(row)
        return
      }
      // 应用内跳转  类型
      console.log(parseInt(row.eventType) === EVENT_TYPE_APP_JUMP)
      if (parseInt(row.eventType) === EVENT_TYPE_APP_JUMP) {
        this.eventbodtForm.pdata = {
          action: "",
          actionCode: "",
          isPay: "",
          albumId: "",
        }
        if (row.eventBody != '') {
          try {
            this.eventbodtForm.pdata = JSON.parse(row.eventBody)
          } catch (error) {
            row.eventBody = ""
            console.log("格式转换失败")
          }
        }
        this.eventbodtForm.dialogVisible = true;
      }
    },
    callbackEvenBodyComfirm() {
      this.formChild.eventBody = JSON.stringify(this.eventbodtForm.pdata)
    },
    // 打开投屏功能的事件响应弹窗，并回显已配置的响应类型
    openScreenCastEventDialog(row) {
      this.screenCastEventForm.pdata = { responseType: "" }
      if (row.eventBody != '') {
        try {
          const eventBody = JSON.parse(row.eventBody)
          this.screenCastEventForm.pdata = { responseType: (eventBody && eventBody.responseType) || "" }
        } catch (error) {
          row.eventBody = ""
          console.log("格式转换失败")
        }
      }
      this.screenCastEventForm.dialogVisible = true;
    },
    callbackScreenCastEventComfirm() {
      this.formChild.eventBody = JSON.stringify(this.screenCastEventForm.pdata)
    },
    getValue(v) {
      this.eventbodtForm.pdata.actionCode = v
      console.log("获取值", v)
    },
    doSearch() {
      // 搜索资源组
      let params = { ...this.searchForm }
      this.pageParent.currentPage = 1
      this.pageParent.pageSize = 10
      // 处理提交数据
      if (Array.isArray(params.clientType) && params.clientType.length) {
        params.clientType = params.clientType.join()
      }
      if (Array.isArray(params.tag) && params.tag.length) {
        params.tag = params.tag.join()
      }
      if (Array.isArray(params.date) && params.date.length) {
        params.staUpdateDate = params.date[0]
        params.endUpdateDate = params.date[1]
      }
      this.onLoadParent(this.pageParent, params)
    },
    searchClear() {
      // 清空搜索
      this.searchForm = {}
      this.doSearch()
    },
  }
};
</script>
<style lang="scss" scoped>
@media only screen and (min-width: 992px) {
  .el-col-md-6 {
    width: 30%;
  }
}

.resourceConfig {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.leftBox {
  width: 50%;
}

.rightBox {
  flex: 1;
}

.tit {
  font-size: 18px;
  font-weight: 700;
}

.uidsSlot {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.uidsSlot_text>span {
  color: #1f98fc;
}

.uidsSlot_btn {
  display: flex;
  justify-content: space-between;
  width: 200px;
  height: 28px;
  line-height: 28px;
}

.resourceConfig {
  /deep/.el-form-item__label {
    width: 0;
    display: none;
  }

  /deep/.el-form-item__content {
    margin-left: 0 !important;
  }

  /deep/.avue-form__menu--center {
    text-align: left;
  }

  // 搜索和新增按钮行样式
  .search-add-row {
    margin-bottom: 16px;
    border-radius: 4px;
    
    .el-form {
      margin-bottom: 0;
    }
    
    .el-form-item {
      margin-bottom: 0;
      margin-right: 16px;
    }
    
    .el-form-item:last-child {
      margin-right: 0;
    }
  }

}
</style>
